import {
    AUCTION_EVENT_AUTO_BID,
    AUCTION_EVENT_IAAI, AUCTION_EVENT_RESERVE,
    AUCTION_EVENT_SCROLL_TO_CURRENT_LOT,
    AUCTION_EVENT_SHOW_POPUP,
    IAAI_EVENT_ASKING_AMOUNT_SET_EVENT,
    IAAI_EVENT_AUCTION_ENDED_EVENT,
    IAAI_EVENT_AUCTION_JOINED,
    IAAI_EVENT_AUCTION_PAUSED_EVENT,
    IAAI_EVENT_AUCTION_RESUMED_EVENT,
    IAAI_EVENT_AUCTION_STARTED_EVENT,
    IAAI_EVENT_AUTO_BID_MODIFY_EVENT,
    IAAI_EVENT_AUTO_BID_PLACE_EVENT,
    IAAI_EVENT_AUTO_BID_REMOVE_EVENT,
    IAAI_EVENT_BID_ACCEPTED_EVENT, IAAI_EVENT_BID_REJECTED_EVENT,
    IAAI_EVENT_BIDDING_ACTIVATE_EVENT,
    IAAI_EVENT_BIDDING_COMPLETED_EVENT,
    IAAI_EVENT_COUNTER_STOPPED_TICK_EVENT,
    IAAI_EVENT_DIGITAL_AUCTION_COUNTDOWN_COMPLETED_EVENT,
    IAAI_EVENT_DIGITAL_AUCTION_TICK_EVENT,
    IAAI_EVENT_INCREMENT_SET_EVENT,
    IAAI_EVENT_ITEM_IF_BID_EVENT,
    IAAI_EVENT_ITEM_NO_BID_EVENT,
    IAAI_EVENT_ITEM_PASS_EVENT,
    IAAI_EVENT_ITEM_PERSISTED_EVENT,
    IAAI_EVENT_ITEM_RERUN_EVENT,
    IAAI_EVENT_ITEM_SOLD_EVENT,
    IAAI_EVENT_LEAVE_AUCTION_CONFIRMATION, IAAI_EVENT_LEAVE_AUCTION_EVENT,
    IAAI_EVENT_NAVIGATED_TO_EVENT, IAAI_EVENT_RESERVE_PRICE_MET_EVENT, IAAI_EVENT_RESERVE_PRICE_REMOVED_EVENT,
    IAAI_EVENT_GUARANTEED_SALE_EVENT,
    IAAI_EVENT_SELECTED_USERS_EVENT, IAAI_EVENT_TRANSIENT_SPENDING_LIMIT_EVENT,
    IAAI_EVENT_WATCHLIST_ITEM_ADDED_EVENT,
    IAAI_EVENT_WATCHLIST_ITEM_REMOVED_EVENT,
    POPUP_LEAVE_AUCTION
} from "@/consts";
import store from "@/store";
import {sendTrackingEvent} from "@/utils/tracking";
import {
    ADDED_WATCHLIST,
    AUCTION_START, REMOVE_JOIN_AUCTION,
    RESET_AUTO_BID,
    RESET_BID_HISTORY,
    RESULT_BIDDING,
    SET_BIDDING_ERROR,
    SET_BIDDING_STARTING,
    SET_BIDDING_STATE, SET_CONNECTED_CLIENT, SET_ERROR_CONNECTED, SET_LOT,
    SET_MAX_AUTO_BID,
    SET_SPENDING_LIMIT,
    SET_USER_ID,
    UPDATE_BID_HISTORY,
    UPDATE_CURRENT_BID_LOT,
    UPDATE_CURRENT_HIGH_BID_LOT,
    UPDATE_CURRENT_LOT,
    UPDATE_MESSAGE_LOT,
    UPDATE_STATUS_AUCTION,
    SET_RESERVE_STATUS,
} from "@/store/mutations.type";
import Vue from 'vue'


function IaaiEventBus() {
    this.iaaiEventBus = new Vue();
    this.iaaiService = null;
}

IaaiEventBus.prototype.init = function (iaaiClient, iaaiService) {
    const self = this
    this.iaaiService = iaaiService;
    this.iaaiClient = iaaiClient

    iaaiClient.on("All", function (e) {
        console.log('All', e)
    });

    iaaiClient.on(IAAI_EVENT_AUCTION_JOINED, function (e) {
        // Check if cookie exists
        const cookieName = 'sold_cars_info';

        if (!document.cookie.split(';').some(item => item.trim().startsWith(cookieName + '='))) {
            // Set cookie for 12 hours with empty array
            const expirationDate = new Date();
            expirationDate.setTime(expirationDate.getTime() + (12 * 60 * 60 * 1000)); // 12 hours

            document.cookie = `${cookieName}=[];expires=${expirationDate.toUTCString()};path=/`;
        }

        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: IAAI_EVENT_AUCTION_JOINED
        });
    });

    iaaiClient.on(IAAI_EVENT_LEAVE_AUCTION_CONFIRMATION, function (e) {
        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: IAAI_EVENT_LEAVE_AUCTION_CONFIRMATION
        });
        var auction = store.getters.auctionItem(e.InternalAuctionId);

        self.iaaiEventBus.$emit(AUCTION_EVENT_SHOW_POPUP, {
            title: 'Warning',
            data: {
                InternalAuctionId: e.InternalAuctionId,
                Name: auction.Name,
                Lane: auction.Lane,
                type: POPUP_LEAVE_AUCTION,
                ExternalAuctionId: auction.ExternalAuctionId,
            }
        })
    });

    iaaiClient.on(IAAI_EVENT_AUCTION_STARTED_EVENT, function (e) {
        store.commit(AUCTION_START, e.InternalAuctionId);
        store.commit(UPDATE_STATUS_AUCTION, {InternalAuctionId: e.InternalAuctionId, Status: e.AuctionStatus})
    });


    iaaiClient.on(IAAI_EVENT_NAVIGATED_TO_EVENT, async function (e) {
        var isStarted = store.getters['isAuctionStarted'](e.InternalAuctionId);

        if (isStarted) {
            store.commit(SET_BIDDING_STATE, {
                InternalAuctionId: e.InternalAuctionId,
                InternalAuctionItemId: e.InternalAuctionItemId,
                BiddingState: true
            });
            store.commit(UPDATE_CURRENT_HIGH_BID_LOT, {
                InternalAuctionId: e.InternalAuctionId,
                Amount: 0,
                text: 'Navigated to event'
            });
            store.commit(RESET_BID_HISTORY, {InternalAuctionId: e.InternalAuctionId,});
            self.iaaiEventBus.$emit(AUCTION_EVENT_SCROLL_TO_CURRENT_LOT, {InternalAuctionItemId: e.InternalAuctionItemId});
            const response = await iaaiClient.auctionService.GetAuctionItem(e.InternalAuctionId, e.InternalAuctionItemId, 'en', true);
            store.commit(UPDATE_CURRENT_LOT, {InternalAuctionId: e.InternalAuctionId, lot: response});
        }
    });

    iaaiClient.on(IAAI_EVENT_BIDDING_ACTIVATE_EVENT, function (e) {
        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: IAAI_EVENT_BIDDING_ACTIVATE_EVENT
        });
        store.commit(SET_BIDDING_STARTING, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            BiddingStarting: true
        });
        const sequenceNumber = store.getters['sequenceNumber']({
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId
        });
        if (sequenceNumber) {
            store.commit(UPDATE_BID_HISTORY, {
                InternalAuctionId: e.InternalAuctionId,
                bidHistory: {Text: `Run #${sequenceNumber}: Bidding Open`}
            });
        }
    });

    iaaiClient.on(IAAI_EVENT_DIGITAL_AUCTION_TICK_EVENT, function (e) {
        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: IAAI_EVENT_DIGITAL_AUCTION_TICK_EVENT,
            IsBonusTime: e.IsBonusTime,
            Tick: e.Tick,
        });
    });

    iaaiClient.on(IAAI_EVENT_COUNTER_STOPPED_TICK_EVENT, function () {
        console.log('finish', IAAI_EVENT_COUNTER_STOPPED_TICK_EVENT);
    });

    iaaiClient.on(IAAI_EVENT_BIDDING_COMPLETED_EVENT, function (e) {
        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: IAAI_EVENT_BID_ACCEPTED_EVENT,
            value: false
        });
        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: IAAI_EVENT_BIDDING_COMPLETED_EVENT
        });
        store.commit(SET_BIDDING_STATE, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            BiddingState: false
        });
        // Reset reserve status when bidding completes
        store.commit(SET_RESERVE_STATUS, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            ReserveOff: false,
            IsGuaranteedSale: false
        });
        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: IAAI_EVENT_AUTO_BID_REMOVE_EVENT
        });
        // store.commit(RESULT_BIDDING, {
        //     InternalAuctionId: e.InternalAuctionId,
        //     InternalAuctionItemId: e.InternalAuctionItemId,
        //     ResultBidding: null
        // })
    });

    iaaiClient.on(IAAI_EVENT_DIGITAL_AUCTION_COUNTDOWN_COMPLETED_EVENT, function () {
        console.log('finish', IAAI_EVENT_DIGITAL_AUCTION_COUNTDOWN_COMPLETED_EVENT);
    });

    iaaiClient.on(IAAI_EVENT_ITEM_PASS_EVENT, function (e) {
        const currentBid = store.getters['currentBidLot']({InternalAuctionId: e.InternalAuctionId});
        store.commit(UPDATE_MESSAGE_LOT, {
            InternalAuctionId: e.InternalAuctionId,
            message: {currentBid, sequenceNumber: e.SequenceNumber, text: 'Item Pass'}
        });
        store.commit(RESULT_BIDDING, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            ResultBidding: {
                text: 'Item Pass',
                currentBid: null
            }
        })
    });

    iaaiClient.on(IAAI_EVENT_ITEM_SOLD_EVENT, function (e) {
        store.commit(UPDATE_MESSAGE_LOT, {
            InternalAuctionId: e.InternalAuctionId,
            message: {currentBid: e.Amount, sequenceNumber: e.SequenceNumber, text: 'Item sold'}
        });

        // Check if current user is the buyer
        if (e.BidderId === store.getters['userId']) {
            const cookieName = 'sold_cars_info';
            const currentLot = store.getters.currentLot(e.InternalAuctionId);
            const auction = store.getters.auctionItem(e.InternalAuctionId);

            // Get current data and expiration time from cookie
            let soldCars = [];
            let existingCookie = document.cookie
                .split('; ')
                .find(row => row.startsWith(cookieName + '='));

            if (existingCookie) {
                soldCars = JSON.parse(existingCookie.split('=')[1]);

                // Check if car with this VIN already exists in cookie to avoid duplicates
                if (!soldCars.some(car => car.vin === currentLot.VIN)) {
                    // Add information about newly sold car
                    soldCars.push({
                        vin: currentLot.Attributes.VIN.Value,
                        price: e.Amount,
                        userId: e.BidderId,
                        lane: `${auction.Lane} - ${auction.Name}`
                    });

                    // Update cookie with the same expiration time
                    document.cookie = `${cookieName}=${JSON.stringify(soldCars)};${existingCookie.split(';').slice(1).join(';')}`;
                }
            }
        }

        store.commit(RESULT_BIDDING, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            ResultBidding: {
                text: 'Item sold',
                currentBid: e.Amount,
                bidderId: e.BidderId === store.getters['userId'] ? e.BidderId : null
            }
        });

        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: IAAI_EVENT_ITEM_SOLD_EVENT
        });
    });

    iaaiClient.on(IAAI_EVENT_ITEM_NO_BID_EVENT, function (e) {
        const currentBid = store.getters['currentBidLot']({InternalAuctionId: e.InternalAuctionId});
        store.commit(UPDATE_MESSAGE_LOT, {
            InternalAuctionId: e.InternalAuctionId,
            message: {currentBid, sequenceNumber: e.SequenceNumber, text: 'Item No Bid'}
        });
        store.commit(RESULT_BIDDING, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            ResultBidding: {
                text: 'Item No Bid',
                currentBid: null
            }
        });
    });

    iaaiClient.on(IAAI_EVENT_ITEM_IF_BID_EVENT, function (e) {
        store.commit(UPDATE_MESSAGE_LOT, {
            InternalAuctionId: e.InternalAuctionId,
            message: {currentBid: e.Amount, sequenceNumber: e.SequenceNumber, text: 'Item on approval'}
        });

        // Check if current user is the buyer
        if (e.BidderId === store.getters['userId']) {
            const cookieName = 'sold_cars_info';
            const currentLot = store.getters.currentLot(e.InternalAuctionId);
            const auction = store.getters.auctionItem(e.InternalAuctionId);

            // Get current data and expiration time from cookie
            let soldCars = [];
            let existingCookie = document.cookie
                .split('; ')
                .find(row => row.startsWith(cookieName + '='));

            if (existingCookie) {
                soldCars = JSON.parse(existingCookie.split('=')[1]);

                // Check if car with this VIN already exists in cookie to avoid duplicates
                if (!soldCars.some(car => car.vin === currentLot.VIN)) {
                    // Add information about if bid car
                    soldCars.push({
                        vin: currentLot.Attributes.VIN.Value,
                        price: e.Amount,
                        userId: e.BidderId,
                        lane: `${auction.Lane} - ${auction.Name}`
                    });

                    // Update cookie with the same expiration time
                    document.cookie = `${cookieName}=${JSON.stringify(soldCars)};${existingCookie.split(';').slice(1).join(';')}`;

                    // Remove the car from array after 20 minutes
                    setTimeout(() => {
                        let currentCookie = document.cookie
                            .split('; ')
                            .find(row => row.startsWith(cookieName + '='));

                        if (currentCookie) {
                            let currentSoldCars = JSON.parse(currentCookie.split('=')[1]);
                            // Remove car with matching VIN
                            currentSoldCars = currentSoldCars.filter(car => car.vin !== currentLot.VIN);
                            // Update cookie with filtered array
                            document.cookie = `${cookieName}=${JSON.stringify(currentSoldCars)};${currentCookie.split(';').slice(1).join(';')}`;
                        }
                    }, 20 * 60 * 1000); // 20 minutes in milliseconds
                }
            }
        }

        store.commit(RESULT_BIDDING, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            ResultBidding: {
                text: 'Item on approval',
                currentBid: e.Amount,
                bidderId: e.BidderId === store.getters['userId'] ? e.BidderId : null
            }
        });

        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: IAAI_EVENT_ITEM_IF_BID_EVENT
        });
    });

    iaaiClient.on(IAAI_EVENT_ITEM_RERUN_EVENT, function (e) {
        const currentBid = store.getters['currentBidLot']({InternalAuctionId: e.InternalAuctionId});
        store.commit(UPDATE_MESSAGE_LOT, {
            InternalAuctionId: e.InternalAuctionId,
            message: {currentBid, sequenceNumber: e.SequenceNumber, text: 'Item Rerun'}
        });
        store.commit(RESULT_BIDDING, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            ResultBidding: {
                text: 'Item Rerun',
                currentBid: null
            }
        })
    });

    iaaiClient.on(IAAI_EVENT_AUCTION_ENDED_EVENT, function (e) {
        store.commit(UPDATE_STATUS_AUCTION, {InternalAuctionId: e.InternalAuctionId, Status: e.AuctionStatus})
        store.commit(UPDATE_CURRENT_LOT, {InternalAuctionId: e.InternalAuctionId, delete: true});
    });

    iaaiClient.on(IAAI_EVENT_AUCTION_PAUSED_EVENT, function (e) {
        store.commit(UPDATE_STATUS_AUCTION, {InternalAuctionId: e.InternalAuctionId, Status: e.AuctionStatus})
    });

    iaaiClient.on(IAAI_EVENT_AUCTION_RESUMED_EVENT, function (e) {
        store.commit(UPDATE_STATUS_AUCTION, {InternalAuctionId: e.InternalAuctionId, Status: e.AuctionStatus})
    });

    iaaiClient.on(IAAI_EVENT_ITEM_PERSISTED_EVENT, function (e) {
        console.log('Item Persisted', e);
    });

    iaaiClient.on(IAAI_EVENT_INCREMENT_SET_EVENT, function (e) {
        console.log(e);
    });

    iaaiClient.on(IAAI_EVENT_ASKING_AMOUNT_SET_EVENT, function (e) {
        store.commit(UPDATE_CURRENT_BID_LOT, {
            InternalAuctionId: e.InternalAuctionId,
            Amount: e.Amount
        })
    });

    iaaiClient.on(IAAI_EVENT_BID_ACCEPTED_EVENT, function (e) {
        store.commit(UPDATE_BID_HISTORY, {
            InternalAuctionId: e.InternalAuctionId,
            bidHistory: {Amount: e.Amount, Display: e.Display, Text: `Bid $${e.Amount}, ${e.Display}`}
        });
        store.commit(UPDATE_CURRENT_HIGH_BID_LOT, {
            InternalAuctionId: e.InternalAuctionId,
            Amount: e.Amount, Display: e.Display, Bidder: e.BidderId === store.getters['userId']
        });
        store.commit(SET_BIDDING_ERROR, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            BiddingError: ''
        });

        const id = store.getters['userId'];
        const maxAutoBidGetter = store.getters['maxAutoBid'];
        const currentMaxAutoBid = typeof maxAutoBidGetter === 'function'
            ? maxAutoBidGetter({
                InternalAuctionId: e.InternalAuctionId,
                InternalAuctionItemId: e.InternalAuctionItemId
            })
            : null;
        const numericMaxAutoBid = Number(currentMaxAutoBid);
        const isCurrentUserBid = e.BidderId === id;
        const isManualBid = e.BidderType !== 2; // 2 = AutoBid
        const hasActiveAutoBid = currentMaxAutoBid !== null && currentMaxAutoBid !== undefined && !isNaN(numericMaxAutoBid);
        const shouldResetAutoBidFallback = isCurrentUserBid && isManualBid && hasActiveAutoBid && e.Amount >= numericMaxAutoBid;

        if (shouldResetAutoBidFallback) {
            store.commit(SET_MAX_AUTO_BID, {
                InternalAuctionId: e.InternalAuctionId,
                InternalAuctionItemId: e.InternalAuctionItemId,
                MaxAutoBid: null
            });
            store.commit(RESET_AUTO_BID, {
                InternalAuctionId: e.InternalAuctionId,
            });

            if (window.Sentry) {
                window.Sentry.captureMessage('AutoBid fallback reset after manual bid accepted', {
                    level: 'info',
                    tags: {
                        feature: 'auto_bidding',
                        eventType: 'manual_bid_fallback_reset',
                    },
                    contexts: {
                        auction: {
                            auctionId: e.InternalAuctionId,
                            itemId: e.InternalAuctionItemId,
                        },
                        bidding: {
                            acceptedAmount: e.Amount,
                            bidderType: e.BidderType,
                            previousMaxAutoBid: numericMaxAutoBid,
                        },
                    },
                    extra: {
                        reason: 'manual bid accepted above or equal to current max autobid',
                    }
                });
            }
        }

        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: IAAI_EVENT_BID_ACCEPTED_EVENT,
            value: e.BidderId === id
        });
    });

    iaaiClient.on(IAAI_EVENT_BID_REJECTED_EVENT, function (e) {
        let text = '';
        let sentryLevel = 'warning';
        let errorCategory = 'expected';

        switch (e.Reason) {
            case 3:
                text = 'Wrong (less than current) bid amount placed'
                errorCategory = 'bid_too_low';
                break;
            case 9:
                text = 'CountDown is Complete';
                errorCategory = 'countdown_complete';
                break;
            case 10:
                text = 'Spending Limit has been reached';
                errorCategory = 'spending_limit_reached';
                break;
            default:
                text = 'Sorry, there was an error. Try again.';
                sentryLevel = 'error';
                errorCategory = 'unknown_reason';

                // Send to Sentry for unknown error codes with full context
                if (window.Sentry) {
                    window.Sentry.captureMessage('Bid Rejected - Unknown Reason Code', {
                        level: sentryLevel,
                        tags: {
                            feature: 'bidding',
                            errorType: 'bid_rejected',
                            reasonCode: String(e.Reason),
                            category: errorCategory,
                        },
                        contexts: {
                            auction: {
                                auctionId: e.InternalAuctionId,
                                itemId: e.InternalAuctionItemId,
                            },
                            bidding: {
                                reasonCode: e.Reason,
                                reasonText: text,
                                currentBid: store.getters['currentBidLot']({InternalAuctionId: e.InternalAuctionId}),
                                highBid: store.getters['currentHighBidAmount']({
                                    InternalAuctionId: e.InternalAuctionId,
                                    InternalAuctionItemId: e.InternalAuctionItemId
                                }),
                            },
                            user: {
                                userId: store.getters['userId'],
                            },
                        },
                        extra: {
                            fullEventData: e,
                            userVisibleMessage: text,
                        }
                    });
                }
                break;
        }

        // Add breadcrumb for all bid rejections
        if (window.Sentry) {
            window.Sentry.addBreadcrumb({
                category: 'bidding',
                message: `Bid Rejected: ${text}`,
                level: errorCategory === 'unknown_reason' ? 'error' : 'info',
                data: {
                    reasonCode: e.Reason,
                    category: errorCategory,
                    auctionId: e.InternalAuctionId,
                    itemId: e.InternalAuctionItemId,
                }
            });
        }

        store.commit(SET_BIDDING_ERROR, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            BiddingError: text
        });
    });

    iaaiClient.on(IAAI_EVENT_AUTO_BID_PLACE_EVENT, function (e) {
        store.commit(SET_MAX_AUTO_BID, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            MaxAutoBid: e.Amount
        });
        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: AUCTION_EVENT_AUTO_BID
        });
    });

    iaaiClient.on(IAAI_EVENT_AUTO_BID_MODIFY_EVENT, function (e) {
        store.commit(SET_MAX_AUTO_BID, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            MaxAutoBid: e.Amount
        });
        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: AUCTION_EVENT_AUTO_BID
        });
    });

    iaaiClient.on(IAAI_EVENT_AUTO_BID_REMOVE_EVENT, function (e) {
        store.commit(SET_MAX_AUTO_BID, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            MaxAutoBid: null
        });
        store.commit(RESET_AUTO_BID, {
            InternalAuctionId: e.InternalAuctionId,
        });
        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: IAAI_EVENT_AUTO_BID_REMOVE_EVENT
        });
    });

    iaaiClient.on(IAAI_EVENT_WATCHLIST_ITEM_ADDED_EVENT, function (e) {
        store.commit(ADDED_WATCHLIST, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            Value: true
        })
    });

    iaaiClient.on(IAAI_EVENT_WATCHLIST_ITEM_REMOVED_EVENT, function (e) {

        store.commit(ADDED_WATCHLIST, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            Value: false
        })
    });

    iaaiClient.on(IAAI_EVENT_TRANSIENT_SPENDING_LIMIT_EVENT, function (e) {
        try {
            // Reset cookie when receiving new spending limits to avoid old session data affecting new session
            const cookieName = 'sold_cars_info';
            const expirationDate = new Date();
            expirationDate.setTime(expirationDate.getTime() + (12 * 60 * 60 * 1000)); // 12 hours
            document.cookie = `${cookieName}=[];expires=${expirationDate.toUTCString()};path=/`;

            // Validate incoming data
            if (typeof e.Limit !== 'number' || typeof e.AmountSpent !== 'number') {
                console.error('Invalid spending limit event data:', e);

                // Send to Sentry for monitoring with clear structure
                if (window.Sentry) {
                    window.Sentry.captureMessage('Invalid Spending Limit Data Received', {
                        level: "warning",
                        tags: {
                            feature: 'spending_limits',
                            errorType: 'data_validation_failed',
                            dataIssue: 'invalid_number_type',
                        },
                        contexts: {
                            validation: {
                                limitType: typeof e.Limit,
                                limitValue: e.Limit,
                                amountSpentType: typeof e.AmountSpent,
                                amountSpentValue: e.AmountSpent,
                                expectedType: 'number',
                            },
                            user: {
                                userId: store.getters['userId'],
                            },
                        },
                        extra: {
                            fullEventData: e,
                            receivedAt: new Date().toISOString(),
                        }
                    });
                }
                return;
            }

            const limit = e.Limit - e.AmountSpent;
            store.commit(SET_SPENDING_LIMIT, limit);

            // Add breadcrumb for successful limit update
            if (window.Sentry) {
                window.Sentry.addBreadcrumb({
                    category: 'spending_limits',
                    message: 'Spending limit updated successfully',
                    level: 'info',
                    data: {
                        totalLimit: e.Limit,
                        amountSpent: e.AmountSpent,
                        remainingLimit: limit,
                    }
                });
            }
        } catch (error) {
            console.error('Error processing spending limit event:', error);

            // Send error to Sentry with full context
            if (window.Sentry) {
                window.Sentry.captureException(error, {
                    level: 'error',
                    tags: {
                        feature: 'spending_limits',
                        errorType: 'processing_error',
                    },
                    contexts: {
                        event: {
                            type: 'IAAI_EVENT_TRANSIENT_SPENDING_LIMIT_EVENT',
                            data: e,
                        },
                        user: {
                            userId: store.getters['userId'],
                        },
                    },
                    extra: {
                        errorMessage: error.message,
                        errorStack: error.stack,
                        eventData: e,
                    }
                });
            }
        }
    });

    iaaiClient.on(IAAI_EVENT_SELECTED_USERS_EVENT, function (e) {
        // Reset cookie on new authorization to prevent old session data from affecting new session
        const cookieName = 'sold_cars_info';
        const expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + (12 * 60 * 60 * 1000)); // 12 hours
        document.cookie = `${cookieName}=[];expires=${expirationDate.toUTCString()};path=/`;

        const userId = e.LiveUserRoles[0].Identity.Id;
        store.commit(SET_USER_ID, userId);

        // Set Sentry user context for better error tracking
        if (window.Sentry) {
            window.Sentry.setUser({
                id: userId,
            });

            // Add breadcrumb for successful authorization
            window.Sentry.addBreadcrumb({
                category: 'auth',
                message: 'User authorized successfully',
                level: 'info',
                data: {
                    userId: userId,
                    timestamp: new Date().toISOString(),
                }
            });
        }

        // Send tracking event for successful authorization
        sendTrackingEvent('authorize', {
            user_id: userId
        });
    });

    iaaiClient.on(IAAI_EVENT_RESERVE_PRICE_REMOVED_EVENT, function (e) {
        store.commit(UPDATE_BID_HISTORY, {
            InternalAuctionId: e.InternalAuctionId,
            bidHistory: {Text: 'RESERVE OFF'}
        });
        store.commit(SET_RESERVE_STATUS, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            ReserveOff: true,
            IsGuaranteedSale: false
        });
        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: AUCTION_EVENT_RESERVE
        });
    });

    iaaiClient.on(IAAI_EVENT_RESERVE_PRICE_MET_EVENT, function (e) {
        store.commit(UPDATE_BID_HISTORY, {
            InternalAuctionId: e.InternalAuctionId,
            bidHistory: {Text: 'RESERVE OFF'}
        });
        store.commit(SET_RESERVE_STATUS, {
            InternalAuctionId: e.InternalAuctionId,
            InternalAuctionItemId: e.InternalAuctionItemId,
            ReserveOff: true,
            IsGuaranteedSale: false
        });
        self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
            iaaiEvent: AUCTION_EVENT_RESERVE
        });
    });

    iaaiClient.on(IAAI_EVENT_GUARANTEED_SALE_EVENT, function (e) {
        // GuaranteedSaleEvent indicates that reserve was met during pre-bidding
        // ReserveOffFlag=true means item will sell when it comes on the block
        if (e.ReserveOffFlag) {
            store.commit(UPDATE_BID_HISTORY, {
                InternalAuctionId: e.InternalAuctionId,
                bidHistory: {Text: 'GUARANTEED SALE - RESERVE MET IN PRE-BIDDING'}
            });
            store.commit(SET_RESERVE_STATUS, {
                InternalAuctionId: e.InternalAuctionId,
                InternalAuctionItemId: e.InternalAuctionItemId,
                ReserveOff: true,
                IsGuaranteedSale: true
            });
            self.iaaiEventBus.$emit(AUCTION_EVENT_IAAI + e.InternalAuctionId, {
                iaaiEvent: AUCTION_EVENT_RESERVE,
                isGuaranteedSale: true
            });

            // Add breadcrumb for monitoring
            if (window.Sentry) {
                window.Sentry.addBreadcrumb({
                    category: 'auction',
                    message: 'Guaranteed Sale Event - Reserve met in pre-bidding',
                    level: 'info',
                    data: {
                        auctionId: e.InternalAuctionId,
                        itemId: e.InternalAuctionItemId,
                        reserveOffFlag: e.ReserveOffFlag,
                    }
                });
            }
        }
    });

    iaaiClient.on(IAAI_EVENT_LEAVE_AUCTION_EVENT, function (e) {
        self.iaaiService.leaveAuction(e.InternalAuctionId, function () {
            store.commit(SET_LOT, {InternalAuctionId: e.InternalAuctionId, delete: true});
            store.commit(REMOVE_JOIN_AUCTION, e.InternalAuctionId)
            let joinedAuctions = JSON.parse(sessionStorage.getItem('joinedAuctions')) || {};
            delete joinedAuctions[e.InternalAuctionId];
            sessionStorage.setItem('joinedAuctions', JSON.stringify(joinedAuctions));
        });
    });

    iaaiClient.start()
        .then(function () {
            console.log('client start success')
            store.commit(SET_CONNECTED_CLIENT, false);

            // Add breadcrumb for successful connection
            if (window.Sentry) {
                window.Sentry.addBreadcrumb({
                    category: 'connection',
                    message: 'SignalR client connected successfully',
                    level: 'info',
                    data: {
                        timestamp: new Date().toISOString(),
                    }
                });
            }
        })
        .catch(function (error) {
            console.error("SignalR connection failed", error)

            // Send detailed error to Sentry
            if (window.Sentry) {
                window.Sentry.captureException(error, {
                    level: 'error',
                    tags: {
                        feature: 'connection',
                        errorType: 'signalr_connection_failed',
                    },
                    contexts: {
                        connection: {
                            type: 'SignalR',
                            state: iaaiClient.connection?.state || 'unknown',
                            url: iaaiClient.connection?.url || 'unknown',
                        },
                    },
                    extra: {
                        errorMessage: error.message,
                        errorStack: error.stack,
                        connectionDetails: {
                            readyState: iaaiClient.connection?.state,
                            transport: iaaiClient.connection?.transport?.name,
                        }
                    }
                });
            }

            store.commit(SET_CONNECTED_CLIENT, false);
            store.commit(SET_ERROR_CONNECTED, 'An error has occurred. Try again.');
        });

    return self.iaaiEventBus
}

export default IaaiEventBus;
